module.exports = __webpack_public_path__ + "img/4.a1cd0017.jpg";